'use client';

import './home-mobile.scss';
import { useRef, useState } from 'react';
import Image from 'next/image';
import { useSwiperSlide } from 'swiper/react';
import TypewriterCycle from '@/components/TextEffects/TypewriterCycle';
import { useScrambleIn } from '@/lib/hooks/useScrambleIn';

const TYPEWRITER_WORDS = ['creatives', 'suits', 'developers', 'programmers', 'artists', 'illustrators', 'designers'];

export default function Intro() {
  const swiperSlide = useSwiperSlide();
  const rootRef = useRef<HTMLDivElement>(null);
  const [isTypewriterEnabled, setIsTypewriterEnabled] = useState(false);

  useScrambleIn(rootRef, {
    active: swiperSlide.isActive,
    staggerMs: 100,
    durationMs: [1000, 1500],
    onDone: () => setIsTypewriterEnabled(true),
  });

  return (
    <div ref={rootRef} className='intro-slide'>
      <p className='text-gray' data-scramble-in>{`< Intro >`}</p>
      <h1>
        <span data-scramble-in>We run on experimentation and </span>
        <span data-scramble-in>creativity.Invented from Advertising and </span>
        <span data-scramble-in>Production spheres, The Other Lab thrives </span>
        <span data-scramble-in>on materialising ideas with a team of </span>
        {isTypewriterEnabled ?
          <>
            <span data-scramble-in>highly skilled</span>
            <span style={{ whiteSpace: 'pre-wrap' }}> </span>
            <TypewriterCycle words={TYPEWRITER_WORDS} />
          </>
          :
          <span data-scramble-in>highly skilled creatives</span>
        }
      </h1>
      <p className={'intro-slide-divider'}>{'<>'}</p>
      <div className="intro-slide-art">
        <p className='intro-slide-caption-top' data-scramble-in aria-hidden="true">CONCOCTING</p>
        <p className='intro-slide-caption-bottom' data-scramble-in aria-hidden="true">CHAOS</p>
        <Image
          src='/assets/image/CIRCLES.png'
          alt=""
          width={3367}
          height={2177}
          sizes="90vw"
          className={'intro-slide-circles'}
          priority
        />
        <div className={'intro-slide-floating-man'}>
          <img
            src="/assets/gif/FLOATINGMAN.webp"
            alt="Floating Man"
            width={1000}
            height={1000}
            style={{ width: '86%', height: 'auto' }}
          />
        </div>
      </div>
      <p className='intro-slide-status' data-scramble-in>Experimentation in progress...</p>
    </div>
  )
}
